var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlide4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220.179,
    height: 186.842,
    viewBox: "0 0 220.179 186.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accompagnement_pour_un_projet_re\\u0301ussi",
    "data-name": "accompagnement pour un projet re\\u0301ussi",
    transform: "translate(-2.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M64.267,286.675c-7.328-5.414-17.646-7.489-25.719-3.266a41.978,41.978,0,0,1,20.89,19.856c1.685,3.43,3.2,7.419,6.679,9a9.383,9.383,0,0,0,6.957,0,27.871,27.871,0,0,0,6.2-3.488l.589-.071c-3.5-8.413-8.266-16.622-15.594-22.035Z",
    transform: "translate(-24.071 -185.872)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M38.328,287.551A35.88,35.88,0,0,1,59.11,295a15.45,15.45,0,0,1,3.386,3.46,8.862,8.862,0,0,1,1.461,4.429,18.341,18.341,0,0,0,.508,4.41,5.426,5.426,0,0,0,3.028,3.244,14.1,14.1,0,0,0,5.53.946c2.084.052,4.25.072,6.145,1.054.23.119.4-.244.171-.363-3.3-1.707-7.151-.593-10.617-1.61a5.5,5.5,0,0,1-3.751-3.052,14.23,14.23,0,0,1-.6-4.468,9.456,9.456,0,0,0-1.267-4.384,14.285,14.285,0,0,0-3.24-3.578,34.811,34.811,0,0,0-9.419-5.445,36.517,36.517,0,0,0-12.151-2.489C38.035,287.143,38.072,287.543,38.328,287.551Z",
    transform: "translate(-23.786 -189.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M91.525,292.13a5.383,5.383,0,0,0-1.265-6.855c-.2-.163-.463.142-.262.3a4.985,4.985,0,0,1,1.163,6.379c-.13.223.234.394.363.171Z",
    transform: "translate(-58.037 -188.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M99.27,329.833a10.376,10.376,0,0,1-7.523-.758c-.23-.118-.4.245-.171.363a10.792,10.792,0,0,0,7.83.773c.249-.07.112-.448-.136-.378Z",
    transform: "translate(-59.055 -217.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M58.754,291.368a3.047,3.047,0,0,1-2.1,1.992c-.25.067-.113.445.136.378a3.414,3.414,0,0,0,2.323-2.2.207.207,0,0,0-.1-.267.2.2,0,0,0-.267.1Z",
    transform: "translate(-35.956 -192.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M19.662,351.721c.157-.038.314-.075.474-.11a40.123,40.123,0,0,1,6.438-.96c.167-.014.337-.026.5-.034a42.3,42.3,0,0,1,15.446,2A41.086,41.086,0,0,1,48.3,355c2.569,1.3,5.252,2.906,8.018,3.267a7.064,7.064,0,0,0,.87.069l10.233-10.767c.011-.036.025-.07.036-.106l.428-.411-.282-.165c-.054-.032-.109-.062-.163-.094-.036-.021-.073-.041-.1-.062l-.034-.018c-.032-.021-.063-.037-.093-.055q-.814-.465-1.637-.92s0,0-.007,0a60.407,60.407,0,0,0-13.176-5.509c-.138-.037-.278-.077-.42-.109a39.2,39.2,0,0,0-6.3-1.127,34.662,34.662,0,0,0-3.5-.146,28.817,28.817,0,0,0-8.884,1.506C27.57,342.273,22.539,346,19.863,351.313c-.068.136-.135.269-.2.408Z",
    transform: "translate(-11.585 -224.006)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M19.46,363.556a35.88,35.88,0,0,1,21.076-6.567,15.453,15.453,0,0,1,4.787.724,8.861,8.861,0,0,1,3.833,2.657,18.341,18.341,0,0,0,3.061,3.215,5.426,5.426,0,0,0,4.371.767,14.1,14.1,0,0,0,4.985-2.574c1.7-1.214,3.437-2.5,5.541-2.859.255-.043.173-.436-.082-.393-3.661.622-6.067,3.832-9.447,5.107a5.5,5.5,0,0,1-4.833-.179,14.231,14.231,0,0,1-3.17-3.205,9.456,9.456,0,0,0-3.651-2.737,14.284,14.284,0,0,0-4.741-.906,34.81,34.81,0,0,0-10.8,1.324,36.515,36.515,0,0,0-11.2,5.328c-.211.149.06.446.269.3Z",
    transform: "translate(-11.223 -235.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M64.737,348.087a5.383,5.383,0,0,0-5.137-4.712c-.258-.009-.284.392-.026.4a4.985,4.985,0,0,1,4.769,4.393c.031.257.424.173.393-.082Z",
    transform: "translate(-37.851 -227.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M93.611,365.739a10.376,10.376,0,0,1-6.463,3.924c-.255.044-.173.437.082.393a10.792,10.792,0,0,0,6.717-4.1C94.1,365.753,93.767,365.534,93.611,365.739Z",
    transform: "translate(-56.097 -241.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M40.541,364.622a3.047,3.047,0,0,1-.474,2.852c-.159.2.178.423.336.22a3.414,3.414,0,0,0,.531-3.154.208.208,0,0,0-.237-.156A.2.2,0,0,0,40.541,364.622Z",
    transform: "translate(-25.048 -240.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M476.625,208.642h-.793V186.918a12.573,12.573,0,0,0-12.573-12.573H417.233a12.573,12.573,0,0,0-12.573,12.573V306.1a12.573,12.573,0,0,0,12.573,12.573h46.026A12.573,12.573,0,0,0,475.832,306.1V224.106h.793Z",
    transform: "translate(-358.997 -174.345)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M470.533,184h-6.008a4.461,4.461,0,0,1-4.13,6.146H434.028A4.461,4.461,0,0,1,429.9,184h-5.611a9.39,9.39,0,0,0-9.39,9.39V312.392a9.39,9.39,0,0,0,9.39,9.39h46.247a9.39,9.39,0,0,0,9.39-9.39h0V193.387a9.39,9.39,0,0,0-9.39-9.39Z",
    transform: "translate(-365.765 -180.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M462.881,376.605a25.93,25.93,0,1,1,25.576-21.693,25.9,25.9,0,0,1-25.576,21.693Zm0-50.836a24.635,24.635,0,0,0-11.312,2.713,24.929,24.929,0,1,0,11.312-2.713Z",
    transform: "translate(-380.347 -273.779)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M326.717,170.838a3.42,3.42,0,0,0-2.462,1.691,4.049,4.049,0,0,0-.393,3.146l-6.036,5.489,2.161,4.818,8.424-7.882a3.86,3.86,0,0,0,2.108-4.452,3.481,3.481,0,0,0-3.8-2.81Z",
    transform: "translate(-208.7 -112.918)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M192.441,208.89a22.207,22.207,0,0,1,.935-4.774c1.166-3.621,8.7-6.6,9.714-6.98l.257-3.385,10.47-1.336,1.328,4.328,3.755,1.671a2.06,2.06,0,0,1,1.1,1.336h0l3.369,1.155,3.325,1.14,11.55-9.653.545.423,3.645,2.821.562.435-14.947,15.995L222.5,210.52l-4.175-1.165-.356,1.716.923,6.03c-5.523,6.553-14.241,7.38-20.571,1.95l-2.372-2.5a19.972,19.972,0,0,1-3.566-7.431Z",
    transform: "translate(-125.766 -127.189)",
    fill: "#c9d2df"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "circle32",
    cx: 8.58,
    cy: 8.889,
    rx: 8.58,
    ry: 8.889,
    transform: "translate(76.132 44.571) rotate(17.902)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M220.35,129.779a6.048,6.048,0,0,0-3.617-2.163,6.252,6.252,0,0,0-4.206.692,9.489,9.489,0,0,0-4.261-.651,4.6,4.6,0,0,0-3.514,2.075,5.484,5.484,0,0,1-.508.885,3.532,3.532,0,0,1-2.639.827l1.46.764-1.455.609,1.98.679a4.742,4.742,0,0,0-1.326,5.179,10.309,10.309,0,0,0,3.224,4.388,5.945,5.945,0,0,0-.229-2.873,2.985,2.985,0,0,1,.539-2.9,3.9,3.9,0,0,1,2.041-.741,109.9,109.9,0,0,1,11.181-1.192,3.5,3.5,0,0,1,1.49.137,3.144,3.144,0,0,1,1.543,2.249,16.045,16.045,0,0,0-.3-4.651,8.015,8.015,0,0,0-1.4-3.317Z",
    transform: "translate(-131.867 -84.297)",
    fill: "#2f0d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M500.053,506.523H485.818a1.864,1.864,0,1,1,0-3.728h14.234a1.864,1.864,0,0,1,0,3.728Z",
    transform: "translate(-411.418 -391.481)",
    fill: "#31AFB4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M320.924,50.265H281.772a1.362,1.362,0,0,1,0-2.723h39.152a1.362,1.362,0,1,1,0,2.723Z",
    transform: "translate(-183.964 -31.43)",
    fill: "#c3e5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M343.529,75.929H281.772a1.362,1.362,0,0,1,0-2.723h61.757a1.362,1.362,0,0,1,0,2.723Z",
    transform: "translate(-183.964 -48.396)",
    fill: "#c3e5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M331.661,100.106H281.772a1.362,1.362,0,0,1,0-2.723h49.889a1.362,1.362,0,0,1,0,2.723Z",
    transform: "translate(-183.964 -64.379)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M309.9,124.195H281.772a1.362,1.362,0,1,1,0-2.723H309.9a1.362,1.362,0,1,1,0,2.723Z",
    transform: "translate(-183.964 -80.304)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M325.445,148.281H281.772a1.362,1.362,0,1,1,0-2.723h43.673a1.362,1.362,0,0,1,0,2.723Z",
    transform: "translate(-183.964 -96.227)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon48",
    d: "M485.958,509.824h-3.509l-1.669-13.535h5.179Z",
    transform: "translate(-316.428 -328.093)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M748.094,710.776H734.7v-.169a5.215,5.215,0,0,1,5.214-5.215h0l2.447-1.857,4.566,1.857h1.17Z",
    transform: "translate(-577.182 -524.189)",
    fill: "#2f0d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M758.73,469.314l-1.548-18.87-1.216-7.083,6.807-1.5,2.259,9.7-1.968,18.283a3.149,3.149,0,1,1-4.334-.524Z",
    transform: "translate(-591.244 -351.196)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon54",
    d: "M430.958,509.824h-3.509l-1.669-13.535h5.179Z",
    transform: "translate(-280.068 -328.093)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M693.085,534.643l-1.556,2.691s-1.709.467-1.151,6.039.583,38.584,3.287,42.647l.489,3.488,5.106.488.129-3.1,6.089-43s3.586,42.214,6.552,43.247l1.071,3.517,4.68,0-.276-4.145.3-52.313Z",
    transform: "translate(-547.81 -412.247)",
    fill: "#2f0d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M693.327,441.659l-.108-.028c3.211-12.01,2.285-27.561.017-44.26V397.3l8.2-7.507h7.117l7.055,4.553a11.266,11.266,0,0,1,5.608,7.159l.007.034-2.795,9.755,2.105,28.212,0,.033-.012.03c-.681,1.728-2.507,1.482-4.621,1.2s-9.888,2.318-12.273,2.318A48.244,48.244,0,0,1,693.327,441.659Z",
    transform: "translate(-549.762 -316.778)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M753.288,411.855l3.057-1.33,4.028,4.939,3.265,15.826L752.455,429.6Z",
    transform: "translate(-588.922 -330.482)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M608.4,465.316l13.977-12.772,4.858-5.3,5.355,4.464-6.286,7.721-15.664,9.632a3.149,3.149,0,1,1-2.239-3.749Z",
    transform: "translate(-491.056 -354.76)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M656.5,429.394l3.871-5.027c.032-.072,3.244-7.249,6.028-10.368,2.856-3.2,5.1-1.563,5.126-1.545l.056.042.155,11.813-10.719,12.808Z",
    transform: "translate(-525.485 -331.471)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle66",
    cx: 6.524,
    cy: 6.524,
    r: 6.524,
    transform: "translate(147.038 70.295) rotate(-80.783)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M706.319,345.831a18.975,18.975,0,0,0-.342-3.308c-.29-1.015-.87-1.885-.58-1.885s.435-.725.435-.725.29-.145.435,0,.29-1.015.29-1.015.145-.435.29-.145.145.145.29-.29.87-.725.87-.725,2.755.145,3.19-.435,5.364-.145,6.379.58,5.509,3.335,4.784,5.509-2.812,7.182-3.335,7.684c-.827.794-1.4,1.08-5.312,1.859-.766.152-4.674-2.347-4.674-2.782s.471-1.814-.286-2c-1.145-.286-1.274,1.161-1.564.726A20.722,20.722,0,0,1,706.319,345.831Z",
    transform: "translate(-557.76 -281.898)",
    fill: "#2f0d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M693.094,710.776H679.7v-.169a5.215,5.215,0,0,1,5.214-5.215h0l2.447-1.857,4.566,1.857h1.169Z",
    transform: "translate(-540.822 -524.189)",
    fill: "#2f0d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M496.007,724.081H276.635a.4.4,0,1,1,0-.807H496.007a.4.4,0,1,1,0,.807Z",
    transform: "translate(-274.094 -537.238)",
    fill: "#cacaca"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide4);
export default __webpack_public_path__ + "static/media/slide4.afee5386ab34ab1fb2f84fdd3c8ec078.svg";
export { ForwardRef as ReactComponent };